interface BalanceEstimateRange {
  key: string;
  label: string;
  midpoint: number;
}

export const BALANCE_ESTIMATE_RANGES: BalanceEstimateRange[] = [
  { key: "under_1k", label: "Under $1k", midpoint: 500 },
  { key: "1k_10k", label: "$1k - $10k", midpoint: 5500 },
  { key: "10k_50k", label: "$10k - $50k", midpoint: 30000 },
  { key: "50k_100k", label: "$50k - $100k", midpoint: 75000 },
  { key: "100k_500k", label: "$100k - $500k", midpoint: 250000 },
  { key: "500k_plus", label: "$500k+", midpoint: 500000 },
  { key: "unsure", label: "Unsure", midpoint: 0 },
];
